document.querySelector('a[href="#zohoForm"].smooth_scroll') && document.querySelector('a[href="#zohoForm"].smooth_scroll').addEventListener("click", doScrolling.bind(null, "#zohoForm", 1e3)), window.addEventListener("load", function() {
    var i = document.getElementById("price__match_myModal"),
        j = document.getElementById("request_callback_myModal"),
        c = document.getElementById("price__match_myBtn"),
        d = document.getElementById("request__callback"),
        e = document.getElementsByClassName("price__match_close")[0],
        f = document.getElementsByClassName("request_callback_close")[0];
    if (c && (c.onclick = function() {
            i.style.display = "block"
        }), d && (d.onclick = function() {
            j.style.display = "block"
        }), e && (e.onclick = function() {
            i.style.display = "none"
        }), f && (f.onclick = function() {
            j.style.display = "none"
        }), window.onclick = function(a) {
            a.target == i && (i.style.display = "none"), a.target == j && (j.style.display = "none")
        }, window.location.href.indexOf("/products/") > -1) {
        var h = document.querySelectorAll(".custom__tab .tablinks");
        h.forEach(function(b, a) {
            h[a].addEventListener("click", function() {
                ! function(d, e) {
                    var a, c, b;
                    for (a = 0, c = document.getElementsByClassName("custom__tabcontent"); a < c.length; a++) c[a].style.display = "none";
                    for (a = 0, b = document.getElementsByClassName("tablinks"); a < b.length; a++) b[a].className = b[a].className.replace(" active", "");
                    document.getElementById(e).style.display = "block", d.classList.add("active")
                }(b, h[a].dataset.tablink)
            })
        }), document.getElementById("default__tab").click()
    }
})

// Must be initialised before setShippingDetail() fires the first request.
var kgShippingRequestId = 0;
setShippingDetail();
var allPincode = [];
$(function() {
    $("#shipping-estimator-zip_popup").autocomplete({
        source: function(request, response) {
            $.ajax({
                url: "https://restaurantequipment.com.au/apps/store/get-pincode-list-page",
                dataType: "json",
                data: {
                    term: request.term
                },
                success: function(data) {
                    if (data.pincodes.length == 0) {
                        var result = [{
                            label: 'No results found',
                            value: response.term
                        }];
                        response(result);
                    } else {
                        response(data.pincodes);
                    }
                    allPincode = data.pincode_list;
                }
            });
        },
        select: function(event, ui) {

             $('#wrong_zip').text('');
            var valid_zip_main = ui.item.value;
            var valid_zip_array = valid_zip_main.split(',');
            var valid_zip = valid_zip_array[valid_zip_array.length - 1].trim();


            if (valid_zip != "" && valid_zip != null) {
                var province_popup = valid_zip_array[1];

                if (province_popup != '' && province_popup != null && valid_zip != "" && valid_zip != null) {
                    $('#shipping-estimator-province').val(province_popup.trim());
                    $('#shipping-estimator-zip').val(valid_zip);
                    $('#shipping-estimator-city').val(valid_zip_array[0]);
                    saveShippingLocation(valid_zip_array[0], province_popup, valid_zip);
                    $('#shipping-estimator').find('.form__submit').trigger('click');
                    check_zip = valid_zip_main;
                    $('#estimate_shipping_popup').addClass('estimate_shipping_popup_loader');
                    $('.icon--shipping-loader').show();
                    estimate_shipping(valid_zip_main)
                } else {
                    $('#wrong_zip').text('Enter valid zipcode');
                }

            } else {
                $('#wrong_zip').text('Enter valid zipcode');
            }


        },
        dataType: 'json',
        autoFocus: true,
        appendTo: '.kg-location-row'
    });
});


// Remember the customer's chosen delivery location so setShippingDetail() can
// restore it on the next product page instead of falling back to Sydney 2000.
function saveShippingLocation(city, province, zip) {
    try {
        localStorage.setItem('zip', String(zip).trim());
        localStorage.setItem('city', String(city).trim());
        localStorage.setItem('province', String(province).trim());
        localStorage.setItem('country', 'Australia');
    } catch (e) {}
}

function setShippingDetail() {
    var checkForZip, country, province, city;
    try {
        checkForZip = localStorage.getItem('zip');
        country = localStorage.getItem('country');
        province = localStorage.getItem('province');
        city = localStorage.getItem('city');
    } catch (e) {}

    if (checkForZip != "" && checkForZip != null && checkForZip != undefined) {
        var zip = checkForZip;

        $('#shipping-estimator-city').val(city);
        $('#shipping-estimator-province').val(province);
        $('#shipping-estimator-zip').val(zip);
        $('#shipping-estimator').find('.form__submit').trigger('click');

        estimate_shipping(city + ', ' + province + ', ' + zip);
    } else {
        // Rental products (tagged Shipping-Type_hosporent) default to Melbourne 3004;
        // every other product keeps the site-wide Sydney 2000 fallback.
        var isRental = (typeof kg_is_hosporent_rental !== 'undefined') && kg_is_hosporent_rental;
        var zip = isRental ? 3004 : 2000;
        var city = isRental ? 'Melbourne' : 'Sydney';
        var province = isRental ? 'VIC' : 'NSW';
        $('#shipping-estimator-zip').val(zip);
        $('#shipping-estimator-city').val(city);
        $('#shipping-estimator-province').val(province);
        $('#shipping-estimator').find('.form__submit').trigger('click');

        estimate_shipping(city + ', ' + province + ', ' + zip);
    }
}
setTimeout(function() {
    getProductInventory();
}, 500);

function getProductInventory() {
    var payload = {};

    payload.zipcode = $('#shipping-estimator-zip').val();
    $('#shipping-estimator-zip_popup').val(payload.zipcode);
    payload.country = 'Australia';
    payload.province = $('#shipping-estimator-province').val();
    payload.product_id = product_id
    payload.variant_id = variant_id
    payload.quantity = $('.quantity-input').val();
    payload.grams = grams
    payload.sku = sku

    $.ajax({
        url: "https://dashboard2.restaurantequipment.com.au/api/get-shipping-location",
        type: "POST",
        dataType: "json",
        contentType: "application/json;",
        data: JSON.stringify(payload),
        success: function(data) {
            if (data.success == true) {

                var kgStockSatus = $(data.view).find('.kg-stock-status').first().text().trim();
                if (!isNaN(kgStockSatus) && kgStockSatus !== '') {
                    $('#kg-inventory-high-count').show();
                } else {
                     $('#kg-inventory-high-text').show();
                }

                $('.custom_shipping').html(data.view);
            }
        },
        error: function(err) {
            // check the err for error details
        }
    });
}

function openModal() {
    // Check if a WA postcode (starting with 6) is present and modal hasn't been shown before
    const postCode = localStorage.getItem('userPostCode');
    const modalAlreadyShown = localStorage.getItem('waStockModalShown');

    if (postCode && postCode.startsWith('6') && !modalAlreadyShown) {
        document.getElementById('waStockModal').style.display = 'flex';
    }
}

function closeModal() {
    document.getElementById('waStockModal').style.display = 'none';
    localStorage.setItem('waStockModalShown', 'true');
}

// Example function to set postcode (you'd typically call this when user enters their postcode)
function setPostCode(code) {
    localStorage.setItem('userPostCode', code);
    // Optionally try to open modal after setting postcode
    openModal();
}

// Close modal if user clicks outside of it
window.onclick = function(event) {
    const modal = document.getElementById('waStockModal');
    if (event.target == modal) {
        modal.style.display = 'none';
        localStorage.setItem('waStockModalShown', 'true');
    }
}

// Service codes are compared case/whitespace-insensitively so small naming
// changes on the backend don't silently drop a rate.
var KG_KERBSIDE_CODES = [
    'standard kerbside - free delivery',
    'standard kerbside delivery',
    'free delivery!',
    'kerbside delivery',
    'free delivery! (kerbside)'
];

function kgNormalizeCode(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
}

function kgIsPremiumRate(item) {
    return kgNormalizeCode(item['service_code']) === 'pfm logistics' ||
        kgNormalizeCode(item['service_name']) === 'premium in-store delivery';
}

// Pickup is shown locally as "Click and Collect", so it is never listed as a delivery rate.
function kgIsPickupRate(item) {
    var text = kgNormalizeCode(item['service_code']) + ' ' + kgNormalizeCode(item['service_name']);
    return /pick ?up|collect/.test(text);
}

function kgFormatRatePrice(item) {
    return '$' + (parseFloat(item['total_price']) / 100).toFixed(2);
}

function kgRateDescription(item, postcodeDetails) {
    if (KG_KERBSIDE_CODES.indexOf(kgNormalizeCode(item['service_code'])) !== -1) {
        return ' <span>Delivery in <span id="shipping_time">' + postcodeDetails + '</span>, courier will call 24hr before</span>';
    }
    if (kgIsPremiumRate(item)) {
        return ' <span>We will contact you after checkout to arrange your delivery</span>';
    }

    var description = String(item['description'] || '')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace('Thursday', 'Thu')
        .replace('Tuesday', 'Tue')
        .replace('Wednesday', 'Wed')
        .replace(
            /(\d{2})\s(January|February|March|April|May|June|July|August|September|October|November|December)\s(\d{4})/g,
            function (_, day, month, year) {
                const monthMap = {
                    January: '01', February: '02', March: '03', April: '04',
                    May: '05', June: '06', July: '07', August: '08',
                    September: '09', October: '10', November: '11', December: '12'
                };
                return `${day} ${monthMap[month]} ${year}`;
            }
        );

    return description.trim() ? '<p>' + description + '</p>' : '';
}

function kgDispatchName(item) {
    var from = item && item['from'];
    if (!from) return '';
    if (from == 'EC') return 'Dispatched from Syd/Melb';

    var stateCityMap = {
        'NSW': 'Sydney',
        'VIC': 'Melbourne',
        'QLD': 'Brisbane',
        'SA': 'Adelaide',
        'WA': 'Perth'
    };
    var city = stateCityMap[from] || '';
    return city ? 'Dispatched from ' + city + ', ' + from : 'Dispatched from ' + from;
}

function kgHideShippingLoaders() {
    $('.skeleton-text-loder').hide();
    $('#estimate_shipping_popup').removeClass('estimate_shipping_popup_loader');
    $('.icon--shipping-loader').hide();
}

// Shows the rate line, delivery text and tooltip for the selected delivery card.
function kgShowDeliveryType(type) {
    $('.kg-rate-standard, .kg-rate-premium, .kg-rate-pickup').hide();
    $('.kg-shipping-days-info, .kg-shipping-premium-info, .kg-shipping-pickup-time-info').hide();
    $('#kg-tag-shipping-cfs, #kg-tag-shipping-from-tag, #kg-tag-shipping-premium-cfs').hide();
    $('#kg-store-locations-hidden').hide();
    $('.kg-location-row').show();

    var hasDescription = $('#kg-tag-shipping-cfs .kg_shipping_rate_cfs-response').html();
    var hasDispatch = $('#kg-tag-shipping-from-tag .kg_shipping_from-tag-response').html();

    if (type === 'premium') {
        $('.kg-rate-premium').show();
        $('#kg-tag-shipping-premium-cfs').show();
        if (hasDispatch) $('#kg-tag-shipping-from-tag').show();
        $('.kg-shipping-premium-info').show();
    } else if (type === 'pickup') {
        $('.kg-rate-pickup').show();
        $('.kg-shipping-pickup-time-info').show();
        $('#kg-store-locations-hidden').show();
        $('.kg-location-row').hide();
    } else {
        $('.kg-rate-standard').show();
        if (hasDescription) $('#kg-tag-shipping-cfs').show();
        if (hasDispatch) $('#kg-tag-shipping-from-tag').show();
        $('.kg-shipping-days-info').show();
    }
}

function estimate_shipping(suggested_value = null) {
    var requestId = ++kgShippingRequestId;
    var payload = {};
    $('.skeleton-text-loder').show();
    payload.zipcode = $('#shipping-estimator-zip').val();
    setPostCode(payload.zipcode)
    payload.country = 'Australia';
    payload.province = $('#shipping-estimator-province').val();
    payload.city = $('#shipping-estimator-city').val();
    $('#shipping-estimator-zip_popup').val(payload.city + ', ' + payload.province + ', ' + payload.zipcode);
    $('.kg-location-text').text(payload.city + ', ' + payload.province + ', ' + payload.zipcode);
    payload.product_id = product_id;
    payload.variant_id = variant_id;
    payload.quantity = $('.quantity-selector--product .quantity-selector__value').first().val();
    if(payload.quantity == undefined){
        payload.quantity = 1;
    }
    payload.sku = sku;
    payload.selected_value = $('#shipping-estimator-zip_popup').val();

    $.ajax({
        url: "https://dashboard2.restaurantequipment.com.au/api/shipping/product-rate/au",
        type: "POST",
        dataType: "json",
        contentType: "application/json;",
        data: JSON.stringify(payload),
        success: function(response) {
            // A newer request (variant/quantity/postcode change) has superseded this one.
            if (requestId !== kgShippingRequestId) return;
            kgHideShippingLoaders();

            var typeDelivery = $('.kg-product-service-row .kg-product-servixe-main .kg-service-checkbox:checked').attr('data-type') || 'standard';
            var data = response && response['data'];
            var shippingRates = (data && data['rates']) || [];
            var sold_out_form = $('.sold_out_form');

            var postcodeDetails = "2-5 Business Days";
            if (response && response['postcodeDetails'] != null) {
                postcodeDetails = response['postcodeDetails']['delivery_time'];
            }

            if (shippingRates.length === 0 || !response || response.success == false) {
                jQuery('#kg-add-to-cart').attr('data-kg-no-rate', '').prop('disabled', true);
                jQuery('.kg-no-shipping-rate-info').text('Please request a quote for this item to check delivery options.');
                jQuery('.kg_shipping_rate_responce').html('<strong>Sorry, no shipping rate.</strong>');
                jQuery('.kg-info-icon:visible').addClass('kg-no-rate-hidden').hide();
                jQuery('.kg-free-delivery-div').hide();

                sold_out_form.show();
                $('.product-form__add-button').hide();
            } else {
                // Undo a previous "no rate" state (e.g. after a variant/quantity change).
                jQuery('#kg-add-to-cart[data-kg-no-rate]').removeAttr('data-kg-no-rate').prop('disabled', false);
                jQuery('.kg-no-shipping-rate-info').text('');
                jQuery('.kg-no-rate-hidden').removeClass('kg-no-rate-hidden').show();
                $('.product-form__add-button').show();

                var standardRates = [];
                var premiumRates = [];
                var hasFreeDelivery = false;

                shippingRates.forEach(function(item) {
                    var code = kgNormalizeCode(item['service_code']);
                    if (parseFloat(item['total_price']) === 0 && (code.indexOf('delivery') !== -1 || code.indexOf('kerbside') !== -1)) {
                        hasFreeDelivery = true;
                    }

                    if (kgIsPremiumRate(item)) {
                        premiumRates.push(item);
                    } else if (!kgIsPickupRate(item)) {
                        // Any non-premium, non-pickup rate (including codes this file
                        // doesn't know about yet) is shown under Standard.
                        standardRates.push(item);
                    }
                });

                var ratesHtml = '';
                standardRates.forEach(function(item) {
                    ratesHtml += '<strong class="kg-rate-standard" style="display:none">' + item['service_name'] + ' ' + kgFormatRatePrice(item) + ' </strong>';
                });
                premiumRates.forEach(function(item) {
                    ratesHtml += '<strong class="kg-rate-premium" style="display:none">' + item['service_name'] + ' ' + kgFormatRatePrice(item) + ' </strong>';
                });
                ratesHtml += '<strong class="kg-rate-pickup" style="display:none">Click and Collect</strong><div class="skeleton-text-loder" style="display:none"></div>';
                jQuery('.kg_shipping_rate_responce').html(ratesHtml);

                // The Standard delivery text comes from the first *standard* rate rather
                // than rates[0], so a premium rate listed first can't put its wording here.
                var description = standardRates.length ? kgRateDescription(standardRates[0], postcodeDetails) : '';
                jQuery('.kg_shipping_rate_cfs-response').html(
                    description ? '<li><span class="kg_shipping_service"><p>' + description + '</p></span></li>' : ''
                );

                var dispatchName = kgDispatchName(standardRates[0] || premiumRates[0]);
                jQuery('.kg_shipping_from-tag-response').html(
                    dispatchName ? '<li><span class="kg_shipping_service"><p>' + dispatchName + '</p></span></li>' : ''
                );

                jQuery('.kg-free-delivery-div').toggle(hasFreeDelivery);
                jQuery('.kg-service-checkbox-premium').toggleClass('kg-disabled-premium', premiumRates.length === 0);

                // Premium was selected but this quote has no premium rate: fall back to Standard.
                if (typeDelivery === 'premium' && premiumRates.length === 0) {
                    typeDelivery = 'standard';
                    $('.kg-service-checkbox').prop('checked', false);
                    $('.kg-service-checkbox[data-type="standard"]').prop('checked', true);
                }
                kgShowDeliveryType(typeDelivery);

                sold_out_form.hide();
            }

            if (suggested_value != null) {
                $.each(allPincode, function(k, v) {
                    if (v.name == suggested_value) {
                        $('body').find('#shipping_time').text(v.delivery_time);
                    }
                });

                $('#shipping-estimator-zip_popup').val(suggested_value);
                $('.kg-location-text').text(suggested_value);
            }
        },
        error: function(err) {
            if (requestId !== kgShippingRequestId) return;
            kgHideShippingLoaders();
            jQuery('.kg_shipping_rate_responce').html('<strong>Delivery price unavailable, please try again.</strong>');
        }
    });
}

function refreshShippingForCurrentLocation() {
    var city = $('#shipping-estimator-city').val();
    var province = $('#shipping-estimator-province').val();
    var zip = $('#shipping-estimator-zip').val();
    if (!zip) return;
    estimate_shipping(city + ', ' + province + ', ' + zip);
}

// product_id/variant_id/sku/grams are rendered for the first available variant
// only, so keep them in sync with the selected variant and re-quote shipping.
document.addEventListener('variant:changed', function(event) {
    var form = event.target;
    if (!form || !form.id || form.id.indexOf('product-form-main-') !== 0) return;
    var variant = event.detail && event.detail.variant;
    if (!variant || !variant.id || variant.id == variant_id) return;

    variant_id = variant.id;
    sku = variant.sku || '';
    if (variant.weight != null) grams = variant.weight;

    refreshShippingForCurrentLocation();
    getProductInventory();
});

var kgQuantityShippingTimer;
$(document).on('change', '.quantity-selector--product .quantity-selector__value', function() {
    clearTimeout(kgQuantityShippingTimer);
    kgQuantityShippingTimer = setTimeout(refreshShippingForCurrentLocation, 400);
});

$('#estimate_shipping_popup').click(function() {
    $('#wrong_zip').text('');
    var valid_zip_main = $('#shipping-estimator-zip_popup').val();
    var valid_zip_array = valid_zip_main.split(',');
    var valid_zip = valid_zip_array[valid_zip_array.length - 1].trim();


    if (valid_zip != "" && valid_zip != null) {
        var province_popup = valid_zip_array[1];

        if (province_popup != '' && province_popup != null && valid_zip != "" && valid_zip != null) {
            $('#shipping-estimator-province').val(province_popup.trim());
            $('#shipping-estimator-zip').val(valid_zip);
            $('#shipping-estimator-city').val(valid_zip_array[0]);
            saveShippingLocation(valid_zip_array[0], province_popup, valid_zip);
            $('#shipping-estimator').find('.form__submit').trigger('click');
            check_zip = valid_zip_main;
            $('#estimate_shipping_popup').addClass('estimate_shipping_popup_loader');
            $('.icon--shipping-loader').show();
            estimate_shipping(valid_zip_main)
        } else {
            $('#wrong_zip').text('Enter valid zipcode');
        }

    } else {
        $('#wrong_zip').text('Enter valid zipcode');
    }
});

$(document).on("click", "#kg_sold_form", function() {
    $('.kg-form-iframe-container').toggleClass("active");
});

$(".kg-addtocart-preorder-btn").click(function() {
    var heightHeader = jQuery(".shopify-section__header").height();
    $('html,body').animate({
        scrollTop: $('.product-info__block-item--payment-card-block').offset().top - heightHeader
    }, 500);
    return false;
});

function sticky_relocate() {
    var window_top = $(window).scrollTop();
    var div_top = $('.product-form__buy-buttons').offset().top;
    var aa = $(".topbar-section").height();
    var bb = $(".product-form__buy-buttons").height();
    var nn = div_top - aa + bb;
    if (window_top > nn) {
        $('#kg-bottom-card-section').addClass('kg-bottom-sticky');
        $('.product-form__payment-container').addClass('kg-bottom-sticky');
    } else {
        $('#kg-bottom-card-section').removeClass('kg-bottom-sticky');
        $('.product-form__payment-container').removeClass('kg-bottom-sticky');
    }
}

$(function() {
    $(window).scroll(sticky_relocate);
    sticky_relocate();
});
$(document).ready(function() {
    $("#kg-tooltip-area").click(function() {
        $(".kg-copied").css("display", "block");
        setTimeout(function() {
            $(".kg-copied").hide();
        }, 1000);
    });
})
$(document).on("click", ".kg-last-price-plus-icon", function() {
    $('.kg-last-price-label').addClass("active");
    $('.kg-last-price-content').show();
});
$(document).on("click", ".kg-last-price-minus-icon", function() {
    $('.kg-last-price-label').removeClass("active");
    $('.kg-last-price-content').hide();
});


$(document).on("click", ".kg-last-price", function() {

    if ($('.kg-last-price-plus-icon').length) {
        var heightHeader = jQuery(".shopify-section__header").height();

        $('html,body').animate({
            scrollTop: $('.kg-last-price-promise-content').offset().top - heightHeader
        }, 1000, function() {
            if (!$('.kg-last-price-label').hasClass('active')) {
                $('.kg-last-price-plus-icon').click();
            }
        });
    }
});
/*
  A .cc-gst click handler here used to show/hide .kg-product-price blocks. The
  per-block .toggle1 inputs it read no longer exist -- there is one sitewide
  checkbox (#kg-gst-state) and CSS does the swap. Removed.
*/


  function updateTitleHeight() {
  var titleHeight = $('.product-block-list .product-block-list__wrapper .product-block-list__item.product-block-list__item--info .card__section .product-meta h1.product-meta__title.heading.h1').outerHeight();
  document.documentElement.style.setProperty('--product-title-height', titleHeight + 'px');

  const priceElement = $('.product-block-list .product-block-list__wrapper .kg-including-price:visible .price-list, .product-block-list .product-block-list__wrapper .kg-excluding-price:visible .price-list');
  const priceMatchElement = $('.product-block-list .product-block-list__wrapper .kg-including-price:visible .price__match, .product-block-list .product-block-list__wrapper .kg-excluding-price:visible .price__match');

  
  let priceWidth = 0;
  let matchWidth = 0;
  
  if (priceElement.length > 0) {
    priceWidth = priceElement.outerWidth();
    document.documentElement.style.setProperty('--product-price-width', priceWidth + 'px');
  }

  
  if (priceMatchElement.length > 0) {
    matchWidth = priceMatchElement.outerWidth();
    document.documentElement.style.setProperty('--price-match-width', matchWidth + 'px');

  }
  
  // Sum both widths
  const totalWidth = priceWidth + matchWidth;
  document.documentElement.style.setProperty('--total-price-block-width', totalWidth + 'px');

    
}


$(document).ready(function () {
  updateTitleHeight();

  // Update on window resize
  $(window).on('resize', function () {
    updateTitleHeight();
  });
});
$(document).on('click', '.kg-edit-icon, .kg-location-text', function (e) {
    e.stopPropagation();
    $('.kg-location-text').hide();
    $('.kg-location-wrap').show();
});

$(document).on('click', function (e) {
    if (
        !$(e.target).closest('.kg-location-wrap').length &&
        !$(e.target).closest('.kg-edit-icon').length &&
        !$(e.target).closest('.kg-location-text').length
    ) {
        $('.kg-location-wrap').hide();
        $('.kg-location-text').show();
    }
});

$('.kg-service-checkbox').on('change', function () {
     if (!this.checked) {
    this.checked = true;
    return;
  }
  $('.kg-service-checkbox').not(this).prop('checked', false);
  kgShowDeliveryType($(this).data('type'));
});
// jQuery(document).ready(function () {
//  function setPriceWidthVar() {
//   var $price = jQuery(
//     '.product-block-list .product-block-list__wrapper ' +
//     '.kg-including-price:visible .price-list .price:visible, ' +
//     '.product-block-list .product-block-list__wrapper ' +
//     '.kg-excluding-price:visible .price-list .price:visible'
//   );

//   if (!$price.length) return;

//   var priceWidth = Math.ceil($price[0].getBoundingClientRect().width);

//   if (priceWidth > 0) {
//     document.documentElement.style.setProperty(
//       '--price-main-width',
//       priceWidth + 'px'
//     );
//   }
// }

//   requestAnimationFrame(function () {
//     setTimeout(setPriceWidthVar, 150);
//   });
//   jQuery(window).on('resize', function () {
//     setTimeout(setPriceWidthVar, 100);
//   });
//   jQuery(document).on('change click', '.kg-gst-toggle1, .kg-gst-toggle1 input', function () {
//   requestAnimationFrame(function () {
//     setTimeout(setPriceWidthVar, 50);
//   });
// });

// });
